/// <amd-module name="Repos/Views/PullRequest/Components/PullRequestDetails/CommitsTab" />
import * as React from "react";
import { ICommit, ICommitsTableProps } from "Repos/Common/Contracts/History";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { Observer } from "VSSUI/Observer";
import { IPullRequestViewService } from "../../PullRequestViewService";

export class CommitsTabContent extends VssComponent {
    public render() {
        const prDetailsService = this.context.pageContext.getService<IPullRequestViewService>("IPullRequestViewService");
        return (
            <Card className="bolt-table-card">
                <Observer commits={prDetailsService.getCommits()} allCommitsUrl={prDetailsService.getAllCommitsUrl()}>
                    {(props: { commits: ICommit[]; allCommitsUrl: string | undefined }) => {
                        return (
                            <div className="flex-column">
                                <WrappedComponent<ICommitsTableProps>
                                    wrappedType="repos-commits-table"
                                    dependencies={["ms.vss-code-web.commits-list"]}
                                    wrappedProps={{
                                        commits: props.commits
                                    }}
                                />
                                {props.allCommitsUrl && (
                                    <FPSLink className="margin-16" href={props.allCommitsUrl}>
                                        {Resources.ViewAllCommits}
                                    </FPSLink>
                                )}
                            </div>
                        );
                    }}
                </Observer>
            </Card>
        );
    }
}
